import { FC, useEffect, useState } from 'react';
import { FlexCol, FlexRow, Paper } from '../common';
import { loadSyncEnabled, saveSyncEnabled } from '../localStorage';
import { useAuth0, User } from '@auth0/auth0-react';
import { Avatar, Button, Col, Row, Switch, Tag, Tooltip } from 'antd';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import { colorHexToRGBA, ARYBALLE_COLOR_CYAN, ARYBALLE_COLOR_GRAY, ARYBALLE_COLOR_BLUE_DARK } from '../utils';

export const ProfilePage: FC = () => {
  const { user, isAuthenticated, getAccessTokenSilently, logout, loginWithRedirect } = useAuth0();
  const [syncEnabled, setSyncEnabled] = useState(loadSyncEnabled());
  const [accessToken, setAccessToken] = useState<string | undefined>();
  const [userInfo, setUserInfo] = useState<User | null>(null);

  let logoutURI = window.location.origin + '/signout/callback';
  if (user?.idp_logout_uri) {
    logoutURI = user.idp_logout_uri;
  }

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      setAccessToken(token);
    });
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (!user || !isAuthenticated) setUserInfo(null);
    else setUserInfo(user);
  }, [isAuthenticated, user]);

  return (
    <Row style={{ height: '100%' }}>
      <Col xs={24} md={12} style={{ height: '100%' }}>
        <Paper>
          <FlexCol style={{ gap: 10 }}>
            <Avatar
              size="large"
              style={{
                backgroundColor: isAuthenticated ? colorHexToRGBA(ARYBALLE_COLOR_CYAN, 1) : colorHexToRGBA(ARYBALLE_COLOR_GRAY, 0.7),
                cursor: 'pointer',
              }}
              icon={<UserOutlined />}
            />
            {isAuthenticated && (
              <FlexCol style={{ height: '100%', justifyContent: 'space-between', alignItems: 'stretch', gap: 5 }}>
                <FlexCol>
                  <b>{userInfo?.name}</b>
                  <i>{userInfo?.email}</i>
                  <Row gutter={[5, 5]} style={{ marginTop: 30 }}>
                    <Col xs={24}>
                      Member of the following <b>groups</b>:
                    </Col>
                    {(userInfo?.assigned_groups as string[])?.map((group) => {
                      return (
                        <Col>
                          <Tag color={colorHexToRGBA(ARYBALLE_COLOR_BLUE_DARK, 0.7)}>
                            <span style={{ fontSize: 14 }}>{group.toUpperCase()}</span>
                          </Tag>
                        </Col>
                      );
                    })}
                  </Row>
                </FlexCol>
                <FlexRow style={{ marginTop: 50, gap: 10, alignItems: 'center' }}>
                  <Tooltip overlay={<>Enable cloud sync to be able to save your records to the cloud</>}>
                    <InfoCircleOutlined /> Enable cloud sync:
                  </Tooltip>
                  <Switch
                    checked={syncEnabled}
                    onChange={(checked) => {
                      setSyncEnabled(checked);
                      saveSyncEnabled(checked);
                    }}
                  />
                </FlexRow>
              </FlexCol>
            )}
          </FlexCol>
        </Paper>
      </Col>
    </Row>
  );
};
